import { BasicClient } from '@/utils/httpClient'
import { AxiosPromise } from 'axios'

export default class User {
  client: BasicClient

  constructor() {
    this.client = new BasicClient()
  }
  resetpass(action: string, ...args: any[]): any {
    let params = { action: action }

    if (args.length > 3) {
      Object.assign(params, {
        email: args[0],
        token: args[1],
        pass: args[2],
        repass: args[3],
      })
    } else {
      Object.assign(params, { user: args[0], email: args[1] })
    }

    return this.client.exec('/users/resetPass', 'POST', params)
  }

  getprofile(): any {
    return this.client.exec('/users/profile', 'GET')
  }

  getprofileEmployee(userId: number): any {
    return this.client.exec(`/v2/admin-mod/profile/users/${userId}`, 'GET')
  }

  getinfoEmployee(userId: number): any {
    return this.client.exec(`/v2/admin-mod/users/${userId}`, 'GET')
  }

  showPdfDownload(idapp, iddoc) {
    return this.client.renderImage(`/documents/view/${idapp}/${iddoc}/pdf/`)
  }

  firstlogin(): any {
    return this.client.exec('/users/firstLogin', 'POST')
  }

  changePass(
    oldPass: string,
    newPass: string,
    repeatPass: string,
    send_mail = 1
  ) {
    let params = {
      oldpass: oldPass,
      pass: newPass,
      repass: repeatPass,
      send_mail: send_mail,
    }

    return this.client.exec('/users/changePass', 'PUT', params)
  }

  changePassV2(oldPass: string, newPass: string, repeatPass: string) {
    let params: object = {}
    if (oldPass) {
      params['oldpass'] = oldPass
    }
    if (newPass) {
      params['pass'] = newPass
    }
    if (repeatPass) {
      params['repass'] = repeatPass
    }
    return this.client.exec('/v2/admin-mod/users/changePass', 'PUT', params)
  }

  changeEmail(password: string, email: string) {
    let params = {
      pass: password,
      email: email,
    }
    return this.client.exec('/users/profile', 'PUT', params)
  }

  relatedUsers() {
    return this.client.exec('/users/related', 'GET')
  }

  switchUser(userId: number) {
    return this.client.exec(`/users/profile/${userId}`, 'PATCH')
  }

  getAvatar(userId: number) {
    return this.client.exec(`/users/${userId}/avatar`, 'GET', { imagen: 0 })
  }
  listSector(): any {
    return this.client.exec('/users/retrieveSector', 'GET')
  }
  listLocacion(): any {
    return this.client.exec('/users/retrieveLocation', 'GET')
  }
  listCargo(): AxiosPromise {
    return this.client.exec('/users/retrieveCargo', 'GET')
  }
  listCentroDeCostos(): any {
    return this.client.exec("/v2/companies/costcenter", "GET");
  }
  listPosition(): any {
    return this.client.exec('/v2/admin-mod/users/position', 'GET')
  }
  listSectorLocacion(): any {
    return this.client.exec('/users/filterSectorLocations', 'GET')
  }
  passwordPolicies() {
    return this.client.exec('/policies/password', 'GET')
  }
  passwordPoliciesV2() {
    return this.client.exec('/v2/user-mod/passwordpolicy', 'GET')
  }
  validPass(pwd) {
    return this.client.exec('/users/isValidPass', 'POST', { pass: pwd })
  }
  getDomain(userId: number) {
    return this.client.exec(`/users/profile/${userId}`, 'GET')
  }
  changeMailResetPass(userId: number, email: string) {
    return this.client.exec(`/users/profile/${userId}`, 'PUT', {
      email: email,
    })
  }
  changePassUser(idu: number, newPass: string, repeatPass: string) {
    let params = {
      pass: newPass,
      repass: repeatPass,
    }
    return this.client.exec(`/users/changePass/${idu}`, 'PUT', params)
  }
  unsubscribe(
    idu: number,
    motivo: string,
    observaciones: string,
    fechaBaja: string
  ) {
    let params = {
      motivo: motivo,
      observaciones: observaciones,
      fechabaja: fechaBaja,
    }
    return this.client.exec(`/employees/${idu}`, 'PUT', params)
  }
  getBirthdays() {
    return this.client.exec('/users/birthdays?option=1', 'GET')
  }
  getRecentHired() {
    return this.client.exec('/users/recentHired', 'GET')
  }
  getTotalIncomeExpenses() {
    return this.client.exec('/v2/admin-mod/users/inout', 'GET')
  }
  getStatus() {
    return this.client.exec('/v2/admin-mod/users/totalbystate', 'GET')
  }
  getMsgMaintenance() {
    return this.client.exec('/notifications/serviceoutage', 'GET')
  }
  getNotificationsPush() {
    return this.client.exec('/notifications/push', 'GET')
  }
  getAbsents() {
    return this.client.exec('/v2/user-mod/licenses/absentUsers', 'GET')
  }
  resetPassRequest(user, email) {
    let params = {
      user: user,
      email: email,
    }
    return this.client.exec('/v2/auth-mod/resetPassword', 'POST', params)
  }
  getNotificationFileUploadLicenses() {
    return this.client.exec('/notifications/fileuploadlicenses', 'GET')
  }
  getDownloadFile() {
    return this.client.exec('/v2/backup/download', 'GET');
  }
  getUserPhoto(id, pending) {
    let url = '/v2/selfservice/me/photo?userId=' + id
    if (pending) url = '/v2/selfservice/me/photo?userId=' + id + '&pending=' + pending
    return this.client.getFile(url);
  }
  getDocumentPDF(idApp, idDoc) {
    return this.client.getFile(`/documents/view/cache/${idApp}/${idDoc}`)
  }
  getDocumentPDFFILE(idApp, idDoc) {
    return this.client.getFile(`/documents/view/${idApp}/${idDoc}/pdf`)
  }
  getDocumentPDFXML(idApp, idDoc) {
    return this.client.getFile(`/documents/view/${idApp}/${idDoc}/xml`)
  }
}
